<template>
  <a class="a-join-telegram" target="_blank" :href="channelUrl">
    <a-icon v-bind="iconProps" />
    <button-text :channel-type="channelType" />
    <a-icon v-bind="arrowIconProps" class="a-join-telegram__arrows" />
  </a>
</template>

<script>
import { propValidator, PROP_TYPES } from '@/utils/validators'
import AIcon from 'shared/AIcon'
import { ICON } from 'shared/AIcon/enums'
import ButtonText from '../ButtonText'
import { CHANNEL_TYPE } from '../enums'

export default {
  name: 'TelegramButton',
  components: { AIcon, ButtonText },
  props: {
    channelType: propValidator(
      [PROP_TYPES.STRING],
      false,
      CHANNEL_TYPE.FM,
      prop => Object.values(CHANNEL_TYPE).includes(prop)
    )
  },
  data() {
    return {
      iconProps: {
        icon: ICON.TELEGRAM_ROUND_WHITE,
        width: 30,
        height: 30,
        original: true
      },
      arrowIconProps: {
        icon: ICON.DOUBLE_ARROW,
        width: 17,
        height: 7,
        original: true
      },
      TELEGRAM_CHANNEL: {
        [CHANNEL_TYPE.FM]: this.$env.TELEGRAM_CHANNEL_FM,
        [CHANNEL_TYPE.CRYPTO]: this.$env.TELEGRAM_CHANNEL_CRYPTO
      }
    }
  },
  computed: {
    channelUrl() {
      return this.TELEGRAM_CHANNEL[this.channelType]
    }
  }
}
</script>

<style lang="scss" scoped>
$c--background: linear-gradient(98deg, #00afe5, #0094d4);
$offset: -4px;

.a-join-telegram {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% + #{$offset});
  height: 40px;
  border-radius: 8px;
  background: $c--background;

  &__arrows {
    position: absolute;
    bottom: 4px;
    right: 4px;
  }

  &:before {
    content: '';
    position: absolute;
    bottom: 0;
    left: $offset;
    width: 10px;
    height: 20px;
    clip-path: polygon(
      0 100%,
      7% 96%,
      13% 93%,
      20% 89%,
      24% 85%,
      28% 79%,
      33% 72%,
      38% 65%,
      43% 60%,
      48% 51%,
      52% 44%,
      55% 38%,
      60% 30%,
      63% 24%,
      67% 19%,
      70% 13%,
      80% 6%,
      100% 0,
      100% 100%
    );
    background-color: #00afe5;
  }
}
</style>
